module.exports = __webpack_public_path__ + "static/18-d8f8a48e03458c039b08316f87ddef62.jpg";